import React, { useState, useContext } from 'react';
import { LockClosedIcon } from '@heroicons/react/solid';
import { Context as AlertContext } from 'contexts/alert';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ReactComponent as Logo } from 'assets/images/logo/logo-full-black.svg';
import { resetPasswordRequest } from 'api/client/requests';

export const ResetPasswordWithToken = () => {
  const [password, setPassword] = useState('');
  const [repeatedPassword, setRepeatedPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { alertController } = useContext(AlertContext);

  const navigate = useNavigate();

  const [searchParams, _] = useSearchParams();

  async function handleSubmit(event) {
    event.preventDefault();

    if (password !== repeatedPassword) {
      alertController.error({ text: 'Passwords do not match' });
      return;
    }

    setIsLoading(true);

    try {
      await resetPasswordRequest({ password, token: searchParams.get('token') });

      alertController.success({ text: 'Password has been reset' });

      navigate('/login', { replace: true });
    } catch (e) {
      alertController.error({ text: 'Failed to reset the password' });
      setIsLoading(false);
    }
  }

  return (
    <div className="flex justify-center items-center h-screen px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full my-12">
        <div className="">
          <Logo className="mx-auto w-60" />
        </div>
        <h1
          className="mt-6 text-lg text-gray-700 text-center"
        >
          Password reset - provide new password
        </h1>
        <form className="mt-8 space-y-6" action="#" method="POST" onSubmit={handleSubmit}>
          <input type="hidden" name="remember" defaultValue="true" />
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="password" className="sr-only">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="Password"
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              />
            </div>
            <div>
              <label htmlFor="repeat-password" className="sr-only">
                Repeat password
              </label>
              <input
                id="repeat-password"
                name="repeat-password"
                type="password"
                autoComplete="repeat-password"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="Repeat password"
                onChange={(e) => {
                  setRepeatedPassword(e.target.value);
                }}
              />
            </div>
          </div>

          <div>
            <button
              disabled={isLoading}
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                <LockClosedIcon
                  className="h-5 w-5 text-indigo-500 group-hover:text-indigo-400"
                  aria-hidden="true"
                />
              </span>
              Reset password
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
